<template>
  <infinite-loading
    ref="infiniteLoading"
    @infinite="infiniteHandler"
  >
    <template #no-more>
      <div v-text="noMoreText" />
    </template>
    <template #no-results>
      <div v-text="noResultsLabel" />
    </template>
  </infinite-loading>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import InfinityScrollIterator from '@/lib/infinityScrollIterator'

export default {
  components: {
    InfiniteLoading
  },
  props: {
    objects: {
      type: Array,
      required: true
    },
    infinityObjects: {
      type: Array,
      required: true
    },
    displayCount: {
      type: Number,
      default: undefined
    },
    noResultsLabel: {
      type: String,
      default: ''
    },
    number: {
      type: Number,
      default: undefined
    }
  },
  data () {
    return {
      infinityScrollIterator: new InfinityScrollIterator(this.objects, this.number)
    }
  },
  computed: {
    noMoreText () {
      return this.displayCount ? `全${this.displayCount}件` : ''
    },
    noResultsText () {
      return this.noResultsLabel
    }
  },
  watch: {
    objects (val) {
      this.resetInfinityScroll(val)
    }
  },
  methods: {
    infiniteHandler ($state) {
      const next = this.infinityScrollIterator.next()
      if (next.done) {
        $state.complete()
      } else {
        this.$emit('update:infinityObjects', [...this.infinityObjects, ...next.value])
        $state.loaded()
      }
    },
    resetInfinityScroll (objects) {
      if (this.$refs.infiniteLoading.stateChanger) {
        this.$refs.infiniteLoading.stateChanger.reset()
      }
      this.$emit('update:infinityObjects', [])
      this.infinityScrollIterator = new InfinityScrollIterator(objects, this.number)
    }
  }
}
</script>
